import { render, staticRenderFns } from "./PageSubsection.vue?vue&type=template&id=0e8302f0&"
import script from "./PageSubsection.vue?vue&type=script&lang=js&"
export * from "./PageSubsection.vue?vue&type=script&lang=js&"
import style0 from "./PageSubsection.vue?vue&type=style&index=0&id=0e8302f0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports